import actions from './action'
import reducers from './reducer'

export {actions, reducers}

export default {
  actions: actions,
  reducers: reducers
}
